import { render, staticRenderFns } from "./Ring.vue?vue&type=template&id=50f82f4a&scoped=true&"
import script from "./Ring.vue?vue&type=script&lang=js&"
export * from "./Ring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f82f4a",
  null
  
)

export default component.exports